import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { IStatusMessage } from '../../shared';
import { IShowErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-indirect-rate',
    templateUrl: './indirect-rate.component.html',
    styleUrls: ['./indirect-rate.component.scss'],
    standalone: false
})
export class IndirectRateComponent implements OnInit {
    @Input() selectedError: IStatusMessage;

    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor() {}

    ngOnInit() {}
}
